import { gql } from '@apollo/client';

export const GET_ACRONIS_TENANTS = gql`
  query getAcronisTenants {
    getAcronisIds
  }
`;

export default null;
